const updateactiveTranslationsIsLoading = (state, action) => {
	const { isLoadingactiveTranslations } = action.payload;
	return { ...state, isLoadingactiveTranslations };
};

const updateactiveTranslations = (state, action) => {
	const { activeTranslations } = action.payload;
	return { ...state, activeTranslations };
};

const updateTranslationKeyToSearch = (state, action) => {
	const { translationKeyToSearch } = action.payload;
	return { ...state, translationKeyToSearch };
};

const updateCurrentActiveLanguage = (state, action) => {
	const { currentActiveLanguage } = action.payload;
	return { ...state, currentActiveLanguage };
};

const updateTranslationsTemplateIsLoading = (state, action) => {
	const { isLoadingTranslationsTemplate } = action.payload;
	return { ...state, isLoadingTranslationsTemplate };
};

const updateDefaultTranslationsTemplate = (state, action) => {
	const { defaultTranslationsTemplate } = action.payload;
	return { ...state, defaultTranslationsTemplate };
};

const updateCurrentLocaleTranslations = (state, action) => {
	const { currentLocaleTranslations } = action.payload;
	return { ...state, currentLocaleTranslations };
};

const updateTranslationsData = (state, action) => {
	const { translationsData } = action.payload;
	return { ...state, translationsData };
};

const updateStagedEdits = (state, action) => {
	const { stagedEdits } = action.payload;
	return { ...state, stagedEdits };
};

const updateCurrentLocaleCustomTranslations = (state, action) => {
	const { currentLocaleCustomTranslations } = action.payload;
	return { ...state, currentLocaleCustomTranslations };
};

const updateStagedSelectedAvailableTranslations = (state, action) => {
	const { stagedSelectedAvailableTranslations } = action.payload;
	return { ...state, stagedSelectedAvailableTranslations };
};

const updateSearchFilteredTranslationData = (state, action) => {
	const { searchFilteredTranslationData } = action.payload;
	return { ...state, searchFilteredTranslationData };
};

const updateIsCustomSearch = (state, action) => {
	const { isCustomSearch } = action.payload;
	return { ...state, isCustomSearch };
};

const updateAvailableADMTranslations = (state, action) => {
	const { availableADMTranslations } = action.payload;
	return { ...state, availableADMTranslations };
};

const updateIsLoadingActiveTranslations = (state, action) => {
	const { isLoadingActiveTranslations } = action.payload;
	return { ...state, isLoadingActiveTranslations };
};

const updateIsLoadingTranslationsData = (state, action) => {
	const { isLoadingTranslationsData } = action.payload;
	return { ...state, isLoadingTranslationsData };
};

const updateShowInLocalLanguage = (state, action) => {
	const { showInLocalLanguage } = action.payload;
	return { ...state, showInLocalLanguage };
};

const updateHasStagedChanges = (state, action) => {
	const { hasStagedChanges } = action.payload;
	return { ...state, hasStagedChanges };
};

const updateIsADMAdminScreen = (state, action) => {
	const { isADMAdminScreen } = action.payload;
	return { ...state, isADMAdminScreen };
};

const updateEditedKeys = (state, action) => {
	const { editedKeys } = action.payload;
	return { ...state, editedKeys };
};

const updateEditedNodeIds = (state, action) => {
	const { editedNodeIds } = action.payload;
	return { ...state, editedNodeIds };
};

export const mainReducers = {
	TRANSLATIONS_UPDATE_ACTIVE_TRANSLATIONS_IS_LOADING:
		updateactiveTranslationsIsLoading,
	TRANSLATIONS_UPDATE_ACTIVE_TRANSLATIONS: updateactiveTranslations,
	TRANSLATIONS_UPDATE_KEY_TO_SEARCH: updateTranslationKeyToSearch,
	TRANSLATIONS_UPDATE_CURRENT_ACTIVE_LANGUAGE: updateCurrentActiveLanguage,
	TRANSLATIONS_UPDATE_TRANSLATIONS_TEMPLATE_IS_LOADING:
		updateTranslationsTemplateIsLoading,
	TRANSLATIONS_UPDATE_DEFAULT_TRANSLATIONS_TEMPLATE:
		updateDefaultTranslationsTemplate,
	TRANSLATIONS_UPDATE_CURRENT_LOCALE_TRANSLATIONS:
		updateCurrentLocaleTranslations,
	TRANSLATIONS_UPDATE_CURRENT_LOCALE_CUSTOM_TRANSLATIONS:
		updateCurrentLocaleCustomTranslations,
	TRANSLATIONS_UPDATE_TRANSLATIONS_DATA: updateTranslationsData,
	TRANSLATIONS_UPDATE_STAGED_EDITS: updateStagedEdits,
	TRANSLATIONS_UPDATE_STAGED_SELECTED_AVAILABLE_TRANSLATIONS:
		updateStagedSelectedAvailableTranslations,
	TRANSLATIONS_UPDATE_SEARCH_FILTERED_TRANSLATIONS_DATA:
		updateSearchFilteredTranslationData,
	TRANSLATIONS_UPDATE_IS_CUSTOM_SEARCH: updateIsCustomSearch,
	TRANSLATIONS_UPDATE_AVAILABLE_ADM_TRANSLATIONS:
		updateAvailableADMTranslations,
	TRANSLATIONS_UPDATE_IS_LOADING_ACTIVE_TRANSLATIONS:
		updateIsLoadingActiveTranslations,
	TRANSLATIONS_UPDATE_IS_LOADING_TRANSLATIONS_DATA:
		updateIsLoadingTranslationsData,
	TRANSLATIONS_UPDATE_SHOW_IN_LOCAL_LANGUAGE: updateShowInLocalLanguage,
	TRANSLATIONS_UPDATE_HAS_STAGED_CHANGES: updateHasStagedChanges,
	TRANSLATIONS_UPDATE_IS_ADM_SCREEN: updateIsADMAdminScreen,
	TRANSLATIONS_UPDATE_EDITED_KEYS: updateEditedKeys,
	TRANSLATIONS_UPDATE_EDITED_NODE_IDS: updateEditedNodeIds,
};

export default mainReducers;
